import SubscribeForm from "./SubscribeForm";
import { plans } from "@/mocks/guaContent";

export default function Plans() {
  return (
    <section id="plans" className="relative bg-primary-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-sm font-semibold text-primary-600 tracking-wide">PLANS · 订阅方案</p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-900">
            多方式可选，总有一款合适你
          </h2>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            瓜田日报每日更新、瓜田周报定期推送、电子报刊深度细品，还有多频道邮件订阅自由搭配。先填个邮箱，剩下的交给我们。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((p, i) => {
            const middle = i === 1;
            return (
              <article
                key={p.name}
                className={
                  "relative flex flex-col rounded-lg border p-6 md:p-7 transition duration-300 hover:-translate-y-1 " +
                  (middle
                    ? "bg-background-50 border-primary-300 ring-2 ring-primary-300/40"
                    : "bg-background-50 border-background-200")
                }
              >
                {middle && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-accent-500 text-white text-xs font-medium px-3 py-1">
                    ✦ 多数读者之选
                  </span>
                )}
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-xl font-bold text-foreground-900">{p.name}</h3>
                  <span
                    className={
                      "text-xs rounded-full px-2.5 py-1 whitespace-nowrap " +
                      (middle ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-800")
                    }
                  >
                    {p.badge}
                  </span>
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{p.tagline}</p>
                <ul className="mt-5 flex flex-col gap-2.5">
                  {p.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-accent-600 mt-0.5 shrink-0"></i>
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href={`#plans-form`}
                  className={
                    "mt-6 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-semibold px-5 py-3 transition " +
                    (middle
                      ? "bg-primary-500 text-white hover:bg-primary-600"
                      : "bg-background-100 text-foreground-800 border border-background-300 hover:bg-secondary-100 hover:border-secondary-300")
                  }
                >
                  选择{p.name}
                </a>
              </article>
            );
          })}
        </div>

        {/* 订阅邮箱 */}
        <div
          id="plans-form"
          className="mt-12 rounded-lg bg-foreground-950 text-white p-6 md:p-10 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center"
        >
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs">
              <i className="ri-mail-send-line text-primary-400"></i> 输入邮箱，立即开通
            </span>
            <h3 className="mt-4 font-heading text-2xl md:text-3xl font-bold leading-snug">
              现在订阅，首期瓜报<br className="hidden sm:block" />
              <span className="text-primary-400">免费尝鲜</span>
            </h3>
            <p className="mt-3 text-sm text-white/75 leading-relaxed">
              首期会先帮你选日报 + 周报组合，之后可在每封邮件里自由调整频率与频道，绝不打扰。
            </p>
          </div>
          <div className="lg:pl-4">
            <SubscribeForm id="subscribe-plans" variant="block" buttonText="免费订阅瓜报" />
            <p className="mt-2 text-xs text-white/55">
              点击即代表你同意接收邮件；可随时退订，我们绝不发送垃圾信息。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}